export default "__VITE_ASSET__b4122171__"